import { useFetchDeviceVideos } from "../../../entities/video/api/use-fetch-video";
import {
    toTemporalZonedDateTime,
    startOf,
    toDate,
} from "../../../shared/lib/temporal";
import { DirectionalCount } from "../../../types/Count";
import { Device } from "../../../types/Device";

export interface DeviceSummary {
    device: Device;
    count: DirectionalCount;
}

export interface DisplayDevice extends DeviceSummary {
    videoId?: string;
    isLoading: boolean;
    isError?: boolean;
}

export function useDisplayDevices(
    summaries?: DeviceSummary[],
    time?: Date,
): DisplayDevice[] {
    const deviceList = summaries ?? [];
    const videoQueries = useFetchDeviceVideos(
        time
            ? deviceList.map((summary) => ({
                  deviceId: summary.device.id,
                  time: toDate(startOf(toTemporalZonedDateTime(time), "day")),
              }))
            : [],
    );

    return deviceList.map((summary, idx) => {
        const videoId = videoQueries[idx]?.data?.[0]?.id;
        const isLoading = videoQueries[idx]?.isLoading ?? false;
        const isError = videoQueries[idx]?.isError ?? false;

        return {
            ...summary,
            videoId,
            isLoading,
            isError,
        };
    });
}
